import {combineReducers, Reducer} from 'redux'
import { TrackerPolicyState } from '@models/tracker-policy'
import {TrackerPoliciesActionTypes} from '@actions/tracker-policy';




// Type-safe initialState!
export const initialState: TrackerPolicyState = {
    allIds:[],
    byId:{},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) =>{
    switch(action.type){
        case TrackerPoliciesActionTypes.FETCH_SUCCESS:{
            const{ data} = action.payload;
            return {
                ...data.reduce( (obj, video) => {
                    obj[video.id] = {
                        ...video,
                        is_fetched: false,
                        ...(state[video.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case TrackerPoliciesActionTypes.CREATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : video
            };
        }

        case TrackerPoliciesActionTypes.UPDATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video
                }
            };
        }

        case TrackerPoliciesActionTypes.FETCH_ITEM_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video,
                    is_fetched: true
                },
            };
        }

        case TrackerPoliciesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case TrackerPoliciesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map( item  => item.id);
        }

        case TrackerPoliciesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case TrackerPoliciesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case TrackerPoliciesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case TrackerPoliciesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case TrackerPoliciesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case TrackerPoliciesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case TrackerPoliciesActionTypes.FETCH_SUCCESS:
        case TrackerPoliciesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<TrackerPolicyState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export { reducer as videoContentReducer }




//Selectors
export const getTrackerPoliciesList = videoContents => videoContents.allIds.map( id => videoContents.byId[id]);

export const getTrackerPolicyById = (videoContents, id) => videoContents.byId[id];